import React from 'react';
import ElementDataRow from 'components/common/element-data/ElementDataRow';
import { ElementMetadataFieldName, IElementDataCategory } from 'components/common/element-data/types';
import ElementDataRowLabel from 'components/common/element-data/ElementDataRowLabel';
import ElementDataRowValue from 'components/common/element-data/ElementDataRowValue';
import useBundleTranslation from 'i18n';
import { getFieldElementMetadataSettings } from 'components/common/element-data/functions';

export default function Category(props: IElementDataCategory) {
    const { t } = useBundleTranslation(['components/common/element_data']);
    const { categoryPath = '', settings } = props;
    const fieldKey: ElementMetadataFieldName = 'category';
    const { fieldMetadataDisplay, fieldMetadataOrder } = getFieldElementMetadataSettings(settings, fieldKey);

    if (!fieldMetadataDisplay || !categoryPath) return null;

    return (
        <ElementDataRow order={fieldMetadataOrder}>
            <ElementDataRowLabel icon={{ type: 'mi', value: 'categories' }}>
                {t(`element_data_label.${fieldKey}`)}
            </ElementDataRowLabel>
            <ElementDataRowValue>{categoryPath}</ElementDataRowValue>
        </ElementDataRow>
    );
}
